import {
  SERVICIO_VALLE_SAGRADO_ID,
  SERVICIO_MARAS_MORAY_ID,
  SERVICIO_INTI_RAYMI_ID,
} from '../../shared/utils/constants';

export const TABLE_COLUMNS = {
  actions: {
    label: '',
    width: 60,
    head_class: 'text-center',
  },
  codigo: {
    width: 65,
  },
  agencia: {
    width: 150,
  },
  codigoAgencia: {
    label: 'File',
    width: 100,
  },
  nombre: {
    width: 150,
  },
  tipo: {
    width: 60,
    head_class: 'text-center',
  },
  nroAdultos: {
    label: 'PAX',
    width: 50,
    head_class: 'text-center',
  },
  nroNinos: {
    label: 'CHD',
    width: 50,
    head_class: 'text-center',
  },
  idioma: {
    width: 60,
    head_class: 'text-center',
  },
  sacsayhuaman: {
    label: 'SACSAY',
    width: 70,
  },
  qoricancha: {
    label: 'QOR',
    width: 50,
  },
  hotel: {
    width: 100,
  },
  horaRecojo: {
    label: 'Recojo',
    width: 50,
    head_class: 'text-center',
  },
  ingresosBTG: {
    label: 'BTG',
    width: 50,
    head_class: 'text-center',
  },
  ingresosCatedral: {
    label: 'CAT',
    width: 50,
    head_class: 'text-center',
  },
  ingresosQoricancha: {
    label: 'QOR',
    width: 50,
    head_class: 'text-center',
  },
  asistente: {
    width: 150,
  },
  recomendacionesGuia: {
    label: 'Recomendaciones',
    width: 150,
  },
  observacion: {
    width: 150,
  },
  estado: {
    width: 80,
  },
  enlaceTren: {
    label: 'Enlace Tren',
    width: 50,
    head_class: 'text-center',
  },
  restaurante: {
    width: 100,
  },
  lunch: {
    width: 60,
  },
  recojoPisac: {
    label: 'Recojo Pisac',
    width: 50,
  },
};

export const PRINT_COLUMNS = {
  codigo: {
    key: 'codigo',
    label: 'Cód.',
    width: 'auto',
  },
  agencia: {
    key: 'agencia',
    label: 'Agencia',
    width: '*',
  },
  codigoAgencia: {
    key: 'codigoAgencia',
    label: 'File',
    width: 25,
  },
  nombre: {
    key: 'nombre',
    label: 'Nombre',
    width: '*',
  },
  tipo: {
    key: 'tipo',
    label: 'Tipo',
    width: 18,
  },
  nroAdultos: {
    key: 'nroAdultos',
    label: 'PAX',
    width: 16,
  },
  nroNinos: {
    key: 'nroNinos',
    label: 'CHD',
    width: 16,
  },
  idioma: {
    key: 'idioma',
    label: 'Id.',
    width: 18,
  },
  hotel: {
    key: 'hotel',
    label: 'Hotel',
    width: '*',
  },
  sacsayhuaman: {
    key: 'sacsayhuaman',
    label: 'SACSAY',
    width: 35,
  },
  qoricancha: {
    key: 'qoricancha',
    label: 'QOR',
    width: 18,
  },
  horaRecojo: {
    key: 'horaRecojo',
    label: 'Recojo',
    width: 25,
  },

  ingresosBTG: {
    key: 'ingresosBTG',
    label: 'BTG',
    width: 15,
  },
  ingresosCatedral: {
    key: 'ingresosCatedral',
    label: 'CAT',
    width: 15,
  },
  ingresosQoricancha: {
    key: 'ingresosQoricancha',
    label: 'QOR',
    width: 15,
  },
  recojoPisac: {
    key: 'recojoPisac',
    label: 'R. Pisac',
    width: 20,
  },
  lunch: {
    key: 'lunch',
    label: 'Lunch',
    width: 25,
  },
  restaurante: {
    key: 'restaurante',
    label: 'Restaurante',
    width: '*',
  },

  enlaceTren: {
    key: 'enlaceTren',
    label: 'Enlace Tren',
    width: 20,
  },
  asistente: {
    key: 'asistente',
    label: 'Asistente',
    width: '*',
  },
  observacion: {
    key: 'observacion',
    label: 'Observaciones',
    width: '*',
  },
};

export const getColumnsPerService = (idServicio) => {
  const columnsPerService = {
    [SERVICIO_VALLE_SAGRADO_ID]: [
      'codigoAgencia',
      'nombre',
      'tipo',
      'nroAdultos',
      'nroNinos',
      'idioma',
      'hotel',
      'horaRecojo',
      'ingresosBTG',
      'asistente',
      'recomendacionesGuia',
      'observacion',
      'estado',
      'enlaceTren',
      'restaurante',
      'lunch',
      'recojoPisac',
    ],
    [SERVICIO_MARAS_MORAY_ID]: [
      'codigoAgencia',
      'nombre',
      'tipo',
      'nroAdultos',
      'nroNinos',
      'idioma',
      'hotel',
      'horaRecojo',
      'ingresosBTG',
      'asistente',
      'recomendacionesGuia',
      'observacion',
      'estado',
    ],
    [SERVICIO_INTI_RAYMI_ID]: [
      'nombre',
      'tipo',
      'nroAdultos',
      'nroNinos',
      'idioma',
      'hotel',
      'sacsayhuaman',
      'qoricancha',
      'lunch',
      'restaurante',
      'observacion',
      'estado',
    ],
  };

  const defaultColumns = [
    'codigoAgencia',
    'nombre',
    'tipo',
    'nroAdultos',
    'nroNinos',
    'idioma',
    'hotel',
    'horaRecojo',
    'ingresosBTG',
    'ingresosCatedral',
    'ingresosQoricancha',
    'asistente',
    'recomendacionesGuia',
    'observacion',
    'estado',
  ];

  const columns = columnsPerService?.[idServicio] || defaultColumns;

  return ['codigo', 'agencia', ...columns];
};

export const getTableColumns = (columns) => {
  const tableColumns = [];

  columns.forEach((column) => {
    tableColumns.push({ key: column, ...TABLE_COLUMNS[column] });
  });

  return tableColumns;
};
